import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconRotate = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M29.773 3.79c-1.077.158-1.809 1.226-1.605 2.341.037.2.127.466.2.589.072.123 1.094 1.192 2.271 2.375l2.14 2.15-1.526.039c-3.626.093-6.76.866-10.037 2.475a24 24 0 0 0-4.874 3.143c-.828.687-2.133 1.968-2.863 2.81-4.67 5.387-6.742 12.461-5.729 19.552 1.01 7.07 5.088 13.342 11.197 17.23 2.805 1.784 6.32 3.066 9.685 3.533 1.467.203 4.292.275 5.374.135 1.144-.147 1.855-.909 1.855-1.986 0-.61-.21-1.089-.649-1.478-.537-.477-.512-.473-2.7-.478-2.441-.007-3.728-.147-5.535-.606a20.57 20.57 0 0 1-12.096-8.606 20.7 20.7 0 0 1-2.88-6.801c-.547-2.431-.627-5.27-.22-7.776.994-6.104 4.76-11.477 10.209-14.563 2.063-1.17 4.592-2.03 6.993-2.38.819-.118 2.625-.25 3.496-.255l.319-.001-2.15 2.16c-1.181 1.188-2.208 2.26-2.28 2.384-.284.479-.306 1.357-.048 1.855.153.297.53.691.827.865.517.303 1.33.316 1.902.03.192-.096 1.515-1.372 4.233-4.085 4.466-4.455 4.334-4.297 4.334-5.193s.132-.738-4.334-5.193c-2.752-2.746-4.04-3.989-4.237-4.087-.353-.177-.83-.243-1.272-.178m19 15.54c-.372.078-.916.443-1.159.779-.275.38-.407.88-.36 1.373.046.5.166.737.76 1.497a21 21 0 0 1 2.259 3.506c.546 1.053.95 1.416 1.705 1.531 1.169.179 2.11-.543 2.329-1.784.085-.484-.267-1.339-1.207-2.936-.7-1.188-2.01-2.988-2.549-3.5-.424-.404-1.156-.595-1.779-.466m5.136 12.603c-.498.119-1.025.562-1.317 1.109-.14.264-.143.309-.123 1.939.029 2.21-.089 3.45-.509 5.371-.22 1.002-.218 1.361.006 1.837.3.638.773 1.002 1.502 1.155.698.146 1.553-.209 1.964-.816.261-.386.511-1.34.754-2.88.397-2.515.426-5.817.059-6.604-.404-.865-1.393-1.335-2.336-1.11m-5.077 16.363c-.542.1-.905.358-1.547 1.094-1.074 1.233-2.509 2.455-4.193 3.573-1.216.807-1.418 1.02-1.587 1.67-.12.462-.121.622-.002 1.022.206.695.697 1.193 1.374 1.394.746.222 1.155.104 2.339-.671 2.022-1.325 3.766-2.819 5.163-4.425.656-.755.783-1.028.78-1.681-.003-.605-.16-1-.555-1.396-.426-.426-1.213-.683-1.772-.58" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconRotate.displayName = 'IconRotate';